module.exports = __webpack_public_path__ + "static/19-399b68fb128e96acc398b0c6e51f93a5.png";